import * as components from './index.components'

const NnaComponents = {}
  
NnaComponents.install = (Vue) => {    
Object.values(components).forEach((component) => {
    Vue.use(component)
})
}

export default NnaComponents
  


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/index.js
// module id = null
// module chunks = 